import { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Col, FormGroup, Row } from "react-bootstrap";
import { getHappycallQuestionList, getTotalHappycallGrades } from "../../store/api/HappycallAPI";
import DatePicker from "react-datepicker2";
import moment from "moment-jalali";
import { ChatRight, Clipboard2DataFill, ExclamationCircleFill, ExclamationTriangleFill, List, PrinterFill } from "react-bootstrap-icons";
import Loader from "react-loader-spinner";
import ModalSelectStaff from "../../../Components/Modals/ModalSelectStaff";
import { BarChart, Bar, YAxis, XAxis, ResponsiveContainer, Legend, CartesianGrid, Label } from "recharts";
import { useDispatch, useSelector } from "react-redux";
import { getAllProvinces } from "../../../store/api/LocationAPI";


export default function TotalHappycallGrades() {
    const dispatch = useDispatch();
    const [dataList, setDataList] = useState(null);
    const inputCDateFrom = useRef()
    const inputCDateTo = useRef()
    const inputDateFrom = useRef()
    const inputDateTo = useRef();
    const inputEDateFrom = useRef();
    const inputEDateTo = useRef();
    const chartContainer = useRef();
    const [questionList, setQuestionList] = useState([]);
    const [searchData, setSearchData] = useState({});
    const [modalStaff, setModalStaff] = useState({ show: false });
    const reportLabel = useRef({});
    const { settings } = useSelector(state => {
        return {
            settings: state.SystemSettingsReducer.systemSettings
        }
    });
    const Happycall_AlarmZone_Zaeef = Number(settings?.find?.(s => s.SettingName === "Happycall_AlarmZone_Zaeef")?.SettingValue ?? -1);
    const Happycall_AlarmZone_MotavasetBePaeen = Number(settings?.find?.(s => s.SettingName === "Happycall_AlarmZone_MotavasetBePaeen")?.SettingValue ?? -1);
    const Happycall_AlarmZone_Motavaset = Number(settings?.find?.(s => s.SettingName === "Happycall_AlarmZone_Motavaset")?.SettingValue ?? -1);
    const Happycall_AlarmZone_MotavasetBeBala = Number(settings?.find?.(s => s.SettingName === "Happycall_AlarmZone_MotavasetBeBala")?.SettingValue ?? -1);
    if (dataList?.Data?.length > 0) {
        const grade = Number(dataList.Data[0].Grade);
        if (grade < Happycall_AlarmZone_Zaeef)
            reportLabel.current = { Color: "#c87239ff", Label: "ضعیف" };
        else if (grade >= Happycall_AlarmZone_Zaeef && grade < Happycall_AlarmZone_MotavasetBePaeen)
            reportLabel.current = { Color: "#c87239", Label: "نسبتا ضعیف" };
        else if (grade >= Happycall_AlarmZone_MotavasetBePaeen && grade < Happycall_AlarmZone_Motavaset)
            reportLabel.current = { Color: "#fcc721", Label: "متوسط رو به پایین" };
        else if (grade >= Happycall_AlarmZone_Motavaset && grade < Happycall_AlarmZone_MotavasetBeBala)
            reportLabel.current = { Color: "#b2b2b2", Label: "متوسط" };
        else if (grade >= Happycall_AlarmZone_MotavasetBeBala)
            reportLabel.current = { Color: "#0d9495", Label: "متوسط رو به بالا" };
    }
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ textAlign: "center" }}>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("Grade", "سطح رضایت")}
                        </span>
                    ))
                }
            </div>
        );
    }
    const onServiceTypeChange = (serviceType) => {
        searchData.ServiceType = serviceType;
        if (!(serviceType?.length > 0)) {
            getHappycallQuestionList(0, true, true, setQuestionList);
        }
        const activeInInstall = serviceType?.toLowerCase() === "install";
        const activeInRepair = serviceType?.toLowerCase() === "repair";

        getHappycallQuestionList(0, activeInInstall, activeInRepair, setQuestionList);
    }
    const search = () => {
        setDataList("PENDING");
        const onGet = (res) => {
            setDataList(res);
        }
        searchData.PServiceType = searchData.ServiceType === "install" ? "نصب" : searchData.ServiceType === "repair" ? "تعمیر" : "";
        searchData.PCreateDateFrom = inputCDateFrom.current.input.value;
        if (searchData.PCreateDateFrom === "") {
            searchData.CreateDateFrom = null;
        }
        searchData.PCreateDateTo = inputCDateTo.current.input.value;
        if (searchData.PCreateDateTo === "") {
            searchData.CreateDateTo = null;
        }
        searchData.PFirstContactDateFrom = inputDateFrom.current.input.value;
        if (searchData.PFirstContactDateFrom === "") {
            searchData.FirstContactDateFrom = null;
        }
        searchData.PFirstContactDateTo = inputDateTo.current.input.value
        if (searchData.PFirstContactDateTo === "") {
            searchData.FirstContactDateTo = null;
        }
        searchData.PEventDateFrom = inputEDateFrom.current.input.value;
        if (searchData.PEventDateFrom === "") {
            searchData.EventDateFrom = null;
        }
        searchData.PEventDateTo = inputEDateTo.current.input.value;
        if (searchData.PEventDateTo === "") {
            searchData.EventDateTo = null;
        }
        searchData.QuestionName = questionList.find(q => Number(q.ID) === Number(searchData.QuestionID))?.QuestionText;
        getTotalHappycallGrades(searchData, onGet);
    }
    const handlePrintChart = () => {
        const chartDiv = chartContainer.current;
        if (!chartDiv) return;

        // گرفتن SVG داخل div نمودار
        const svgElement = chartDiv.querySelector("svg");
        if (!svgElement) return;

        const clonedSVG = svgElement.cloneNode(true);

        // باز کردن پنجره جدید
        const printWindow = window.open("", "_blank", "width=900,height=650");
        if (!printWindow) return;

        // پاک کردن body پنجره جدید
        printWindow.document.body.innerHTML = "";

        // اضافه کردن SVG کلون شده
        printWindow.document.body.appendChild(printWindow.document.importNode(clonedSVG, true));

        // استایل‌ها برای چاپ (اختیاری)
        const style = document.createElement("style");
        style.textContent = `
    svg { width: 600px; height: 300px; }
    text { font-family: Vazir, sans-serif; }
    body { text-align: center; margin: 0; padding: 20px;font-family: Vazir }
  `;
        printWindow.document.head.appendChild(style);

        // چاپ
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };
    const showModalAgency = () => {
        const onSelect = (data) => {
            setSearchData({ ...searchData, AgencyID: data?.ID, AgencyName: data?.LastName });
        }
        setModalStaff({ show: true, forAgency: true, onSelect: onSelect });
    }
    useEffect(() => {
        dispatch(getAllProvinces());
        getHappycallQuestionList(0, true, true, setQuestionList);
    }, []);
    return (
        <div className="container-fluid mt-2" style={{ minHeight: '80vh', textAlign: "right" }}>
            <ModalSelectStaff popData={modalStaff} setPopSelectStaff={setModalStaff} />
            <br />



            <Row className="mt-3">
                <Col md={3} className="rowBorder">
                    <div className="rowTitle">
                        فیلترهای جستجو
                    </div>
                    <div className="form-group">
                        <select className="search-input" onChange={e => onServiceTypeChange(e.target.value)}>
                            <option value="">نوع سرویس را انتخاب کنید</option>
                            <option value="repair">تعمیر</option>
                            <option value="install">نصب</option>
                        </select>
                    </div>
                    <div className="form-group">
                        {questionList === "PENDING" &&
                            <Loader color="#bb1370" type="BallTriangle" width={25} height={25} />
                        }
                        {Array.isArray(questionList) &&
                            <select className='search-input' onChange={e => searchData.QuestionID = e.target.value}>
                                <option value="">مقیاس را انتخاب کنید</option>
                                {
                                    questionList.map((item, i) => <option key={i} value={item.ID}>{item.QuestionText}</option>)
                                }
                            </select>
                        }
                    </div>
                    <div className="form-group">
                        <input className="search-input" value={searchData.AgencyName ?? ""} placeholder="نماینده" />
                        <Button className="btn-input-tiny" onClick={showModalAgency} style={{ top: 4, left: 2 }}><List size={18} /></Button>
                    </div>
                    <div className="form-group">
                        <DatePicker ref={inputDateFrom} isGregorian={false} timePicker={false} className="search-input" placeholder="پذیرش از"
                            value={searchData.FirstContactDateFrom ? moment(searchData.FirstContactDateFrom) : null}
                            onChange={value => { searchData.FirstContactDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className="form-group">
                        <DatePicker ref={inputDateTo} isGregorian={false} timePicker={false} className="search-input" placeholder="پذیرش تا"
                            value={searchData.FirstContactDateTo ? moment(searchData.FirstContactDateTo) : null}
                            onChange={value => { searchData.FirstContactDateTo = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className="form-group">
                        <DatePicker ref={inputCDateFrom} isGregorian={false} timePicker={false} className="search-input" placeholder="ثبت از"
                            value={searchData.CreateDateFrom ? moment(searchData.CreateDateFrom) : null}
                            onChange={value => { searchData.CreateDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className="form-group">
                        <DatePicker ref={inputCDateTo} isGregorian={false} timePicker={false} className="search-input" placeholder="ثبت تا"
                            value={searchData.CreateDateTo ? moment(searchData.CreateDateTo) : null}
                            onChange={value => { searchData.CreateDateTo = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className="form-group">
                        <DatePicker ref={inputEDateFrom} isGregorian={false} timePicker={false} className="search-input" placeholder="انجام از"
                            value={searchData.EventDateFrom ? moment(searchData.EventDateFrom) : null}
                            onChange={value => { searchData.EventDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className="form-group">
                        <DatePicker ref={inputEDateTo} isGregorian={false} timePicker={false} className="search-input" placeholder="انجام تا"
                            value={searchData.EventDateTo ? moment(searchData.EventDateTo) : null}
                            onChange={value => { searchData.EventDateTo = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <Button className="group-Btn mt-1 mb-1" onClick={search}><Clipboard2DataFill size={18} />&nbsp;خروجی گزارش</Button>
                </Col>
                {dataList?.Data?.length > 0 && dataList.Data.some(d => Number(d.Grade) >= 0) ?
                    <>
                        <Col md={3} className="rowBorder" style={{ display: "flex", flexDirection: "column", marginRight: "5px" }}>
                            <div className="rowTitle">امتیاز رضایت مندی</div>
                            <Card style={{ margin: "auto", width: "80%" }}>
                                <Card.Header style={{ backgroundColor: reportLabel.current.Color, textAlign: "center", padding: "10px 8px 8px 10px" }}>
                                    {reportLabel.current.Label}
                                </Card.Header>
                                <Card.Body style={{ textAlign: "center" }}>
                                    <label style={{ color: reportLabel.current.Color, fontWeight: "900px", fontSize: "18px" }}>
                                        {dataList.Data[0].Grade}
                                    </label>

                                </Card.Body>

                            </Card>
                        </Col>
                        <Col md={4} className="rowBorder" style={{ padding: "10px", marginRight: "5px", fontSize: "9px" }}>
                            <div className="rowTitle"><PrinterFill size={23} onClick={handlePrintChart} color="green" className="hoverIcon" /></div>
                            <div ref={chartContainer} style={{ top: "50%", transform: "translateY(-50%)", position: "relative", height: "200px" }}>
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    <BarChart data={dataList.Data}>
                                        <Legend align="center" content={renderLegend} verticalAlign="bottom" style={{ textAlign: "center" }} />
                                        <XAxis dataKey={"Label"} style={{ fontSize: "8px" }} reversed={true} minTickGap={1} width={100} />
                                        <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" padding={{ top: 15 }} tickMargin={5} />
                                        <CartesianGrid />
                                        <Bar dataKey="Grade" fill="#1e7bbdff" label={{ position: 'top' }} isAnimationActive={false} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </Col>

                    </> :
                    <Col md={7} className="rowBorder" style={{ display: "flex", flexDirection: "column" }}>
                        {dataList === "PENDING" ?
                            <Loader type="BallTriangle" width={45} height={45} color="#bb1370" style={{ margin: "auto" }} /> :
                            <div style={{ margin: "auto", textAlign: "center" }}>
                                <ExclamationCircleFill color="#394cc1" size={25} />
                                <div style={{ margin: "auto", fontSize: "16px", fontWeight: "700px", color: "#394cc1" }}>داده ای برای نمایش وجود ندارد</div>
                            </div>
                        }
                    </Col>
                }
            </Row>
        </div>
    )
}